export default __webpack_public_path__ + "static/media/home-events-conference-img-07.b477610e.jpg";